<script lang="ts">
  import CTooltip from '$shared/atoms/CTooltip/CTooltip.svelte';
  import Icon from '$shared/atoms/Icon/Icon.svelte';
import { IconType } from '$shared/constants/IconType';
  import Label from '$provider/constants/Label';
  import type { CaqhDocumentInfo } from '$provider/models/profile/caqh/CaqhDocumentInfo';
  import type { CaqhDocument } from '$provider/models/profile/caqh/CaqhDocument';

  interface Props {
    documentInfo: CaqhDocumentInfo;
    onclick?: (doc: CaqhDocument) => void;
  }

  let { documentInfo, onclick }: Props = $props();

  const onClickFilePath = (doc: CaqhDocument): void => {
    onclick?.(doc);
  };
</script>

<div class="documents-content">
  {#each documentInfo.documents as doc, index}
    {@const downloadInfo = doc?.download}
    {@const isFailed = !!downloadInfo?.isFailed}
    <div class="doc-i" class:odd={(index + 1) % 2 !== 0} class:disabled={isFailed}>
      <div class="filename-content">
        <div class="icon"><Icon value="icon-file" fontSize="18px" size="18px" /></div>
        <div class="filename">{@html doc?.parsedFileName}</div>
      </div>
      <div class="file-info">
        {#if !downloadInfo}
          <div class="text">{Label.DocumentDownloadInfoNotAvailable}</div>
        {:else if isFailed}
          <div class="text">{Label.DocumentNotAvailable}</div>
        {:else}
          <CTooltip label={Label.GoToDocumentLocation} width="auto">
            <div class="icon">
              <Icon
                type={IconType.Button}
                fontSize="18px"
                size="18px"
                value="icon-external-link"
                onclick={() => onClickFilePath(doc)}
              />
            </div>
          </CTooltip>
        {/if}
      </div>
    </div>
  {/each}
</div>

<style>
  .documents-content {
    margin-top: 16px;
  }
  .doc-i {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
  }
  .doc-i.odd {
    background-color: var(--grey-bg) !important;
  }
  .doc-i.disabled {
    opacity: 0.7;
  }
  .doc-i .filename-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    line-height: 20px;
  }
  .doc-i .filename-content .icon {
    display: flex;
    align-items: center;
  }
  .doc-i .filename-content .filename {
    margin-left: 8px;
  }
  .doc-i .file-info .text {
    font-size: 11px;
    color: var(--grey-dark);
    line-height: 18px;
  }
</style>
